import React from 'react';

const CustomDropdownOption = ({ value, name }) => {
  return <option value={value}>{name}</option>;
};

export default CustomDropdownOption;
